import React from 'react';
import { Button, Switch, Tag } from 'antd';
import { getModelTrainingStatus } from '../../../lib/util/status';
import { Model } from '../../../types';
import { Link } from 'react-router-dom';

export const GetModelOverviewTableColumns = (
  onClickUrl: (data: Model) => any,
  onDelete: (data: Model) => any,
  onChange: (data: Model, status: boolean, info: any) => any,
  onRename: (data: Model) => any,
  isMultiflowAlgorithm: boolean | null
) => {
  const columns = [
    {
      title: 'Name',
      key: 'name',
      dataIndex: 'name',
      render: (text: string, record: Model) => (
        <span>
          <Link to={onClickUrl(record)}>{text}</Link>
        </span>
      ),
    },
    {
      title: 'Status',
      key: 'id',
      dataIndex: 'id',
      render: (text: string, record: Model) => (
        <span>
          <Tag color={getModelTrainingStatus(record).color} key={'READY'}>
            {getModelTrainingStatus(record).label}
          </Tag>
        </span>
      ),
    },
    {
      title: 'Mode',
      key: 'flowmode',
      dataIndex: 'flowmode',
      render: (text: string, record: Model) => <span>{record.info.flowMode || ''}</span>,
    },
    {
      title: 'MultiFlow',
      key: 'flowname',
      dataIndex: 'flowname',
      render: (text: string, record: Model) => <span>{record.info.flowName}</span>,
    },
    {
      title: 'Actions',
      key: 'actions',
      dataIndex: 'actions',
      render: (text: string, record: Model) => (
        <span>
          {isMultiflowAlgorithm && (
            <Switch
              style={{ marginRight: '1em' }}
              checked={record.info.active}
              disabled={!record.lastModelVersionId}
              onChange={status => onChange(record, status, record.info)}
            />
          )}
          <Button type="link" size="small" onClick={() => onRename(record)}>
            {isMultiflowAlgorithm ? 'Edit' : 'Rename'}
          </Button>
          <Button type="link" onClick={() => onDelete(record)}>
            Delete
          </Button>
        </span>
      ),
    },
  ];
  return isMultiflowAlgorithm ? columns : columns.filter(column => !['flowmode', 'flowname'].includes(column.key));
};
